import { RootState } from "../../../store";
import { savingsOpportunitiesStateSelector } from "../savingsOpportunitiesStateSelector";

export const savingsOpportunitiesSelectedRowsIdsSelector = (
  state: RootState,
) => {
  return savingsOpportunitiesStateSelector(state).selection.selectedRowsIds;
};
